module.exports = "    /**\n    * @Route(\"/\")\n    */\n    public function index()\n    {\n        $movies = $this->getDoctrine()\n            ->getRepository(Movie::class)\n            ->findAll();\n\n        return $this->render('movies/index.html.twig', [\n            'movies' => $movies,\n        ]);\n    }\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/controller-movie-3.txt
// module id = 625
// module chunks = 166022795811749